import { useContext } from 'react';

import { MainContext, useTranslation } from '@ezbobdev/ui-framework';
import { MaterialTypography } from '@ezbobdev/ui-widgets-ezbob';

import { UlStyled } from './List.styled';

const List = ({ textArray }) => {
  const { actions } = useContext(MainContext);

  const { t } = useTranslation();

  const defaultIconSrc = actions.settings.getUserConfigProp('assets.checkIcon.src');
  const defaultIconAlt = t('assets.checkIcon.alt');

  return (
    <UlStyled>
      {textArray.map(({ text, icon }) => (
        <li className="ListItem" key={text}>
          <img
            className="ListItemImage"
            src={icon?.src ?? defaultIconSrc}
            alt={icon?.alt ?? defaultIconAlt}
            aria-hidden
            fetchPriority="high"
          />
          <MaterialTypography>{text}</MaterialTypography>
        </li>
      ))}
    </UlStyled>
  );
};

export default List;
